import axios from 'axios';
// IPGEOLOCATION Credentials
const ipgeoURL = process.env.REACT_APP_IP_GEO_URL;
const ipgeoApikey = process.env.REACT_APP_IPGEO_APIKEY;

async function getIpAddress() {
    const {data} = await axios.get(`${ipgeoURL}${ipgeoApikey}`);
    return data;
};

export default getIpAddress;